// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.
import {
  defineComponent,
  PeriodPicker,
  RiskVsReturnsGraph,
  SectionContainer,
} from '@shared/ui-kit';
import { useBacktest } from './use-backtest';
import { Loader } from '@shared/advisory/aggregation/components';
import { MultiAsset } from '@shared/portfolio-analytics/components/backtest';
import { BenchmarkSelector } from '@shared/advisory/aggregation/components/benchmark-selector';

export const Backtest = defineComponent({
  displayName: 'Backtest',
  useSetup: useBacktest,
  View: ({
    periodPicker,
    status,
    kpis,
    returns,
    analysis,
    backtest,
    hasHoldings,
    onChangeBenchmark,
    benchmark,
    institutionId,
    onRefresh,
    savedBenchmarks,
  }) => (
    <div className="mt-6 space-y-10">
      <Loader
        status={status}
        shouldDisplayEmptyState={!hasHoldings}
        institution={institutionId}
        onRefresh={onRefresh}
      >
        <div className="flex flex-col items-center justify-center gap-5 md:flex-row md:justify-start">
          <PeriodPicker
            onValueChange={periodPicker.onPeriodChange}
            availableOptions={['YTD', '6M', '1Y', '3Y', '5Y', 'MAX']}
            defaultValue={periodPicker.defaultHist}
          />

          <BenchmarkSelector
            onChange={onChangeBenchmark}
            value={benchmark.ticker}
            savedBenchmarks={savedBenchmarks}
          />
        </div>

        <MultiAsset
          kpis={kpis}
          returns={returns}
          analysis={analysis}
          backtest={backtest}
          feature="aggregator"
        />

        <SectionContainer testId="returns-tab-risk-returns">
          <RiskVsReturnsGraph
            risks={analysis?.risk_returns ?? []}
            benchmark={benchmark.ticker}
          />
        </SectionContainer>
      </Loader>
    </div>
  ),
});
